module.exports = __webpack_public_path__ + "media/images/shared/code39-72655548f1a98c9c6d23f755316aea74.png";